import _ from "lodash";
import {
  Object
} from "core-js";

export default {
  data() {
    return {
      // memberLevelList: {
      //   name: "",
      //   discountModel: "percentage",
      //   discountValue: "",
      //   discountType: "nomalMember",
      //   excludeSingle: false,
      //   excludeFull: false,
      //   freightValue: "",
      //   valuation: {
      //     model: "member",
      //     limit: {
      //       member: false,
      //       normal: false
      //     }
      //   },
      //   growValue: "",
      //   limitPayMoney: "",
      //   limitPayCount: "",
      // }
    }
  },

  computed: {
    openModal: {
      get() {
        return this.$props.open;
      },
      set(open) {
        this.$emit("update:open", open);
      }
    },

    memberLevelList: {
      get() {
        let temp = {
          name: "",
          discountModel: "percentage",
          discountValue: "",
          discountType: "nomalMember",
          excludeSingle: false,
          excludeFull: false,
          freightValue: "",
          valuation: {
            model: "member",
            limit: {
              member: false,
              normal: false
            }
          },
          growValue: "",
          limitPayMoney: "",
          limitPayCount: "",
        };

        if (this.$props.method == 'update') {
          temp = JSON.parse(JSON.stringify(this.$props.levelTemp));
        }

        return temp;
      }
    }
  },

  props: {
    method: {
      type: String
    },
    open: {
      type: Boolean
    },
    levelTemp: {
      type: Object,
      default: {}
    }
  },

  methods: {
    valuationChange() {
      this.memberLevelList.valuation.limit = _.mapValues(this.memberLevelList.valuation.limit, (
        item, key) => {
        return item = false;
      });
    },

    insertOrUpdateMemberList(event) {
      this.$store.dispatch("member/memberLevelSave", this.memberLevelList);

      event.preventDefault();
    }
  },
}
